import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";
import { GeneralDocumentValidationSchema } from "../schemas/create.schema";

interface UseUpdateGeneralDocumentProps {
  id?: string;
  onSuccess: () => void;
  onError: (error: any) => void;
}

export const useUpdateGeneralDocument = ({ id, onSuccess, onError }: UseUpdateGeneralDocumentProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ["updateGeneralDocument", id],
    mutationFn: async ({ form, file }: { form: GeneralDocumentValidationSchema; file: Blob | undefined }) => {

      const payload = {
        ...form,
        kind: form.kind.value,
        file,
      };

      return privateAxios.put(
        `/general_documents/${id}`,
        { general_document: payload },
        { headers: { "content-type": "multipart/form-data" } }
      );
    },
    onSuccess,
    onError,
  });
};
